export default "__VITE_ASSET__DegOqYTs__"